import axios from "../axios/index.js";

const urlGetInformationDetail = "/api/information/detail";
const urlUpdateInformation = "/api/information/update";

export default {
    getDetail() {
        return axios.get(urlGetInformationDetail);
    },

    update(params) {
        return axios.post(urlUpdateInformation, params);
    },
};
